<app-modal-overlay [open]="open" (closeRequest)="onCancel()">
    <div *ngIf="open" role="alertdialog" aria-modal="true" [attr.aria-label]="title" data-test="confirm-dialog">
        <div class="modal-eyebrow" *ngIf="eyebrow" data-test="confirm-eyebrow">{{ eyebrow }}</div>
        <div class="h2 mb-2" data-test="confirm-title">{{ title }}</div>
        <p class="body-sm" *ngIf="message" data-test="confirm-message">{{ message }}</p>
        <div class="flex justify-end gap-2 mt-6">
            <button type="button" class="btn btn-secondary" data-test="confirm-cancel" [disabled]="busy" (click)="onCancel()">{{ cancelLabel }}</button>
            <button type="button" class="btn" [ngClass]="confirmTone === 'primary' ? 'btn-purple' : 'btn-danger'" data-test="confirm-yes" [disabled]="busy" (click)="onConfirm()">{{ busy ? busyLabel : confirmLabel }}</button>
        </div>
    </div>
</app-modal-overlay>
